var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-content-page"},[_c('a',{staticClass:"card-content-page-link",on:{"click":function($event){return _vm.routerPage(_vm.contentPage)}}},[_c('div',{staticClass:"card-content-page__text"},[_c('h3',[_vm._v(_vm._s(_vm.contentPage.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }